// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import GameMode from "./game_mode_type";
import Difficulty from "./difficulty_type";
import QueueStatus from "./queue_status_type";


export default __t.row({
  userId: __t.u64().primaryKey().name("user_id"),
  username: __t.string(),
  get mode() {
    return GameMode;
  },
  get difficulty() {
    return Difficulty;
  },
  eloRating: __t.i32().name("elo_rating"),
  queuedAt: __t.u64().name("queued_at"),
  get status() {
    return QueueStatus;
  },
});
